import { createSelector } from 'reselect'

import { selectJBPSettings } from './selectJBPSettings'

export const selectJBPSettingsCurrentFYear = createSelector(
  [selectJBPSettings],
  ({ currentFYear }) => currentFYear
)
